import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './utils/metaPixel';
// Initialize Meta Pixel immediately on page load
initMetaPixel();
render(<App data-id="element-202" />, document.getElementById('root'));